import { ThemeConfig } from 'antd/es/config-provider/context'
import { token } from './token'

export const Theme: ThemeConfig = {
  token,
}
